module.exports = __webpack_public_path__ + "img/bg.55123394.jpg";